var render, staticRenderFns
import script from "./InterfaceText.vue?vue&type=script&lang=js&"
export * from "./InterfaceText.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceText.vue?vue&type=style&index=0&id=5bcf9d8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf9d8d",
  null
  
)

export default component.exports